import React, { useMemo } from 'react';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';

import Table from 'components/Table';
import Stack from 'ui-kit/Stack';
import { Tooltip, Typography } from 'ui-kit';
import { Pagination } from 'antd';

import PurchasesTable from 'components/Orders/PurchasesTable';
import { IOrder } from 'api/order_sdk';

import './styles.scss';
import {
  DATE_OF_PURCHASE_COLUMN,
  getActionColumn,
  GUEST_EMAIL_COLUMN,
  GUEST_NAME_COLUMN,
  GUEST_PAID_COLUMN,
  GUEST_PHONE_COLUMN,
} from './utils';

export interface IOrdersTable {
  orders: Array<IOrder>;
  currentPage: number;
  count: number;
  loading: boolean;
  setPage: (page: number) => void;
  onRefundCompleted: () => void;
  inStoreContext?: boolean;
}

const OrdersTable = ({
  orders,
  currentPage,
  count,
  loading,
  setPage,
  onRefundCompleted,
  inStoreContext = false,
}: IOrdersTable) => {
  const columns = useMemo(() => {
    if (inStoreContext) {
      return [
        {
          title: 'Sale Number',
          dataIndex: 'order_number',
          key: 'order_number',
          render: (text, order, index) => (
            <Typography variant="body1" rows={1} className="store-name-cell">
              {count - index}
            </Typography>
          ),
        },
        DATE_OF_PURCHASE_COLUMN,
        GUEST_NAME_COLUMN,
        GUEST_EMAIL_COLUMN,
        GUEST_PHONE_COLUMN,
        GUEST_PAID_COLUMN,
        getActionColumn({ onRefundCompleted }),
      ];
    }

    return [
      DATE_OF_PURCHASE_COLUMN,
      {
        title: 'Sale Number',
        dataIndex: 'order_number',
        key: 'order_number',
        render: (text) => (
          <Typography variant="body2" className="store-name-cell">
            {text}
          </Typography>
        ),
      },
      {
        title: 'Store',
        dataIndex: 'store.store_name',
        key: 'store_name',
        render: (text, order) => (
          <Tooltip title={order.store?.store_name}>
            <Typography variant="body2" rows={1} className="store-name-cell">
              {order.store?.store_name}
            </Typography>
          </Tooltip>
        ),
      },
      GUEST_NAME_COLUMN,
      GUEST_EMAIL_COLUMN,
      GUEST_PHONE_COLUMN,
      GUEST_PAID_COLUMN,
      getActionColumn({ onRefundCompleted }),
    ];
  }, [inStoreContext, count]);

  return (
    <Stack flexDirection="column" alignItems="center">
      <Table
        loading={loading}
        className="DashboardSales_table"
        dataSource={orders}
        scroll={{ x: 500 }}
        rowKey="id"
        pagination={false}
        expandable={{
          expandIcon: ({ expanded, onExpand, record }) =>
            expanded ? (
              <MinusCircleOutlined
                style={{ fontSize: '18px' }}
                onClick={(e) => onExpand(record, e)}
              />
            ) : (
              <PlusCircleOutlined
                style={{ fontSize: '18px' }}
                onClick={(e) => onExpand(record, e)}
              />
            ),
          expandedRowRender: (order: IOrder) => (
            <PurchasesTable order={order} onRefundCompleted={onRefundCompleted} />
          ),
        }}
        columns={columns}
      />
      <Pagination onChange={setPage} current={currentPage} total={count} showSizeChanger={false} />
    </Stack>
  );
};

export default OrdersTable;
